// Settings sub-page URL segments. Defined here (not imported from pages/settings/nav-items) so this
// constants module stays a leaf — importing nav-items pulls the entire ~2400-file settings page into
// every chunk that touches a route constant (including the login bundle). nav-items imports these back.
export const MY_PROFILE_LOCATION = 'myprofile';
export const SIGN_IN_AND_SECURITY_LOCATION = 'signin-security';

export const ARCHIVES_PATH = '/archive';
export const INVOICES_PATH = '/invoices';
export const BASE_ORDERS_PATH = '/orders';
export const BASE_SHIPMENTS_PATH = '/shipments';
export const BASE_INSIGHTS_PATH = '/dashboard';
export const BASE_PRODUCTS_PATH = '/products';
export const BASE_CUSTOMERS_PATH = '/customers';
export const SUPPLIES_PATH = '/supplies';
export const BASE_SCAN_PATH = '/scan';
export const BASE_SETTINGS_PATH = '/settings';
export const SHIPMENTS_RETURNS_PATH = '/shipments/returns';
export const BASE_RETURNS_PATH = '/returns';
export const CARRIERS_PATH = '/carriers';
export const PROVIDERS_PATH = '/providers';
export const TRANSACTIONS_PATH = '/transactions';
export const BALANCE_HISTORY_PATH = '/balance';
export const SUBSCRIPTION_PATH = '/subscription';
export const PAYMENTS_AND_SUBSCRIPTION_PATH = '/payments';
export const BATCHES_PATH = '/batches';
export const DASHBOARD_PATH = '/dashboard';
export const REPORT_PATH = '/reports';
export const TRANSACTIONS_REPORT_PATH = '/PostageTransactions';
export const SHIPMENT_PICKUPS_PATH = '/shipment-pickups';
export const ONBOARD_PATH = '/onboard';
export const SHIPPED_RECENT_PATH = '/shipped-recent';
export const ORDER_DETAILS_PATH = '/order';
export const HOME_PAGE_PATH = '/home';
export const FTU_WIZARD_PATH = `${HOME_PAGE_PATH}/setup-wizard`;
export const FTU_WIZARD_STEP_PATH = `${FTU_WIZARD_PATH}/:step?`;
export const FULFILLMENT_PATH = '/fulfillment';

export const BASE_AUTOMATIONS_PATH = '/automations';
export const AUTOMATIONS_TEMPLATES_PATH = `${BASE_AUTOMATIONS_PATH}/templates`;
export const AUTOMATIONS_RULES_PATH = `${BASE_AUTOMATIONS_PATH}/rules`;
export const AUTOMATIONS_WORKFLOWS_PATH = `${AUTOMATIONS_RULES_PATH}?tab=workflows`;

export const BASE_FULFILLMENTS_PAGE_PATH = '/fulfillments';
export const FULFILLMENTS_GRID_PATH = 'grid';
export const FULFILLMENTS_DASHBOARD_PATH = 'dashboard';
export const FULFILLMENT_RESOURCES_PATH = 'resources';
export const FULFILLMENTS_GRID_RECENT_PATH = 'grid/recent';
export const FULFILLMENTS_GRID_PENDING_PATH = 'grid/pending';
export const FULFILLMENTS_GRID_IN_TRANSIT_PATH = 'grid/in-transit';
export const FULFILLMENTS_GRID_DELIVERED_PATH = 'grid/delivered';
export const FULFILLMENTS_GRID_DELIVERY_EXCEPTION_PATH = 'grid/delivery-exception';
export const FULFILLMENTS_GRID_CANCELLED_PATH = 'grid/cancelled';
export const FULFILLMENTS_RETURNS_PATH = 'returns';
export const FULFILLMENTS_ASN_PATH = 'advanced-shipping-notice';
export const FULL_FULFILLMENTS_RETURNS_PATH = '/fulfillments/returns';
export const SHIPMENTS_FULFILLMENTS_RETURNS_PATH = '/shipments/fulfillments/returns';
const AUTOMATION_RULES_PATH = '/automationrules';
const INSURANCE_SETTINGS_PATH = '/insurance';
const INTERNATIONAL_SETTINGS_PATH = '/international';
const PACKINGSLIPS_SETTINGS_PATH = '/packingslips';
const PICKLIST_SETTINGS_PATH = '/picklist';
const PRINTING_SETTINGS_PATH = '/printing';
const CONNECT_SETTINGS_PATH = '/connect';
const INVENTORY_SETTINGS_PATH = '/inventorysettings';
const PACKAGES_SETTINGS_PATH = '/packages';
const SETTINGS_INVENTORY_WAREHOUSE_PATH = '/inventorywarehouses';
const SETTINGS_RATE_SHOPPER_PATH = '/rateShopper';
const ADDON_MARKETPLACE_PATH = '/addonmarketplace';
export const REFUND_ASSIST_SETTINGS_PATH = `${BASE_SETTINGS_PATH}/refundassist`;
export const BASE_STORE_SETUP_URL = `${BASE_SETTINGS_PATH}/stores`;
export const WAREHOUSES_PATH = `${BASE_SETTINGS_PATH}/warehouses`;
export const COMPLETE_PAYMENT_REDIRECT = '/complete-payment-redirect';
export const APP_STORE_INSTALL_PATH = '/app-store/install';
export const APP_STORE_INSTALLED_PATH = '/app-store/installed';
export const SETUP_PATH = '/setup';
export const INVENTORY_SYNC_PATH = 'addonmarketplace?addonActivateModalOpen=true&addonCode=InventorySync';
export const PRODUCT_BUNDLES_PATH = 'addonmarketplace?addonActivateModalOpen=true&addonCode=ProductBundles';

export const ORDER_DETAILS_MODAL_FULFILLMENT_PLAN_PATH_SEGMENT = 'active';
export const ORDER_DETAILS_MODAL_FULFILLMENT_PLAN_PATH = `/${ORDER_DETAILS_MODAL_FULFILLMENT_PLAN_PATH_SEGMENT}`;

export const ORDER_DETAILS_RETURN_PATH_SEGMENT = 'return';
export const ORDER_DETAILS_ENHANCED_RETURN_PATH_SEGMENT = 'enhanced-return';
export const ORDER_DETAILS_RETURN_PATH = `/${ORDER_DETAILS_RETURN_PATH_SEGMENT}`;
export const ORDER_DETAILS_ENHANCED_RETURN_PATH = `/${ORDER_DETAILS_ENHANCED_RETURN_PATH_SEGMENT}`;

export const FULFILLMENTS_RETURNS_RETURN_PATH = ':statusViewId/return/:fulfillmentId';
export const FULFILLMENTS_RETURNS_ENHANCED_RETURN_PATH = 'enhanced-return/:fulfillmentId';
export const FULFILLMENTS_RETURNS_STATUS_ENHANCED_RETURN_PATH = ':statusViewId/enhanced-return/:fulfillmentId';

export const ORDERS_REJECTED_FULFILLMENT_PAGE_URL = `${BASE_ORDERS_PATH}/rejected-fulfillment`;
export const ORDERS_ALERTS_SHIP_TOGETHER_PATH = `${BASE_ORDERS_PATH}/alerts/shiptogether`;

export const ORDERS_AWAITING_SHIPMENT_PAGE_URL = `${BASE_ORDERS_PATH}/awaiting-shipment`;
export const ORDERS_ON_HOLD_PAGE_URL = `${BASE_ORDERS_PATH}/on-hold`;
export const ORDERS_AWAITING_PAYMENT = `${BASE_ORDERS_PATH}/awaiting-payment`;
export const ORDERS_RECENTLY_SHIPPED = `${BASE_SHIPMENTS_PATH}/shipped-recent`;

export const ORDERS_BATCHES_PATH = `${BASE_ORDERS_PATH}${BATCHES_PATH}`;
export const SHIPMENTS_BATCHES_PATH = `${BASE_SHIPMENTS_PATH}${BATCHES_PATH}`;

const getSettingsPath = () => BASE_SETTINGS_PATH;
export const getCarriersPath = () => `${getSettingsPath()}${CARRIERS_PATH}`;
export const getCarriersPathForNegotiatedRates = () => `${getCarriersPath()}?tab=1`;
export const getFreightProvidersTabPath = () => `${getCarriersPath()}?tab=2`;
// This now should have only one consumer, the redirect to catch any potential remaining links to /settings/providers and redirect them to /settings/carriers
//   Leaving to catch any potential unknowns
export const getProvidersPath = () => `${getSettingsPath()}${PROVIDERS_PATH}`;
export const getTransactionHistoryPath = () => {
  return `${getCarriersPath()}${TRANSACTIONS_PATH}`;
};
export const SHIPPING_WORKFLOWS_PATH = `${BASE_SETTINGS_PATH}/workflow`;
export const getTransactionHistoryPathForNewCarriers = () => `${getCarriersPath()}${TRANSACTIONS_PATH}`;
export const getSubscriptionInvoiceHistoryPath = () => `${getTransactionHistoryPath()}${SUBSCRIPTION_PATH}`;
export const getBalanceHistoryPathForWalletId = (walletId) => `${getTransactionHistoryPath()}/${walletId}${BALANCE_HISTORY_PATH}`;
export const getSubscriptionPath = () => `${getSettingsPath()}${PAYMENTS_AND_SUBSCRIPTION_PATH}`;
export const getArchivePath = () => `${getSubscriptionPath()}${ARCHIVES_PATH}`;
export const getConnectSettingsPath = () => `${getSettingsPath()}${CONNECT_SETTINGS_PATH}`;
export const getDashboardPath = () => DASHBOARD_PATH;
export const getPostageTransactionsPath = () => `${getDashboardPath()}${REPORT_PATH}${TRANSACTIONS_REPORT_PATH}`;
export const getInvoicesPath = () => `${getSubscriptionPath()}${INVOICES_PATH}`;
export const getShippedRecentPath = () => `${BASE_SHIPMENTS_PATH}${SHIPPED_RECENT_PATH}`;
export const getShipmentPickupsPath = () => `${BASE_SHIPMENTS_PATH}${SHIPMENT_PICKUPS_PATH}`;

export const getActiveFulfillmentPlanIdFromOrderDetailsUrl = () => {
  const pathname = window.location.pathname;
  const activeIndex = pathname.indexOf(ORDER_DETAILS_MODAL_FULFILLMENT_PLAN_PATH);
  if (activeIndex === -1) {
    return;
  }
  const activeSlice = pathname.slice(activeIndex);
  const splitSlice = activeSlice.split('/');
  const activeTermIndex = splitSlice.indexOf(ORDER_DETAILS_MODAL_FULFILLMENT_PLAN_PATH_SEGMENT);
  const fulfillmentPlanId = splitSlice[activeTermIndex + 1];
  return fulfillmentPlanId.split('?')[0];
};

export const getInsuranceSettingsPath = () => `${getSettingsPath()}${INSURANCE_SETTINGS_PATH}`;
export const getAutomationsSettingsPath = () => `${getSettingsPath()}${AUTOMATION_RULES_PATH}`;
export const getAutomationWorkflowsSettingsPath = () => `${getSettingsPath()}${AUTOMATION_RULES_PATH}?tab=workflows`;
export const getAutomationWorkflowPath = (idOrNew) => `${getSettingsPath()}${AUTOMATION_RULES_PATH}/${idOrNew}?tab=workflows`;
export const getInternationalSettingsPath = () => `${getSettingsPath()}${INTERNATIONAL_SETTINGS_PATH}`;
export const getPackingslipsSettingsPath = () => `${getSettingsPath()}${PACKINGSLIPS_SETTINGS_PATH}`;
export const getPickListSettingsPath = () => `${getSettingsPath()}${PICKLIST_SETTINGS_PATH}`;
export const getInventorySyncSettingPath = () => `${getSettingsPath()}/${INVENTORY_SYNC_PATH}`;
export const getInventorySettingsPath = () => `${getSettingsPath()}${INVENTORY_SETTINGS_PATH}`;
export const getPrintingSettingsPath = () => `${getSettingsPath()}${PRINTING_SETTINGS_PATH}`;
export const getMyProfilePath = () => `${getSettingsPath()}/${MY_PROFILE_LOCATION}`;
export const getSignInAndSecurityPath = () => `${getSettingsPath()}/${SIGN_IN_AND_SECURITY_LOCATION}`;
export const getInventoryWarehousePath = () => `${getSettingsPath()}${SETTINGS_INVENTORY_WAREHOUSE_PATH}`;
export const getPackagesSizeSettingsPath = () => `${getSettingsPath()}${PACKAGES_SETTINGS_PATH}/tab=sets`;
export const getRateShopperSettingsPath = () => `${getSettingsPath()}${SETTINGS_RATE_SHOPPER_PATH}`;
export const getFulfillmentProviderSettingsPath = () => `${getSettingsPath()}${FULFILLMENT_PATH}`;
export const getAddonMarketplacePath = () => `${getSettingsPath()}${ADDON_MARKETPLACE_PATH}`;
export const getPickingSettingsPath = () => `${getSettingsPath()}/warehousepicking`;
export const getProfitabilityOptimizationPath = () => `${BASE_INSIGHTS_PATH}/profitability-optimization`;
export const getPurchaseOrdersPath = () => `${BASE_PRODUCTS_PATH}${PURCHASE_ORDERS_PATH}`;

export const eodBasePathname = '/shipments/end-of-day';
export const printFormsPathname = (jobGuid) => `${eodBasePathname}/close-shipments/${jobGuid}`;
export const SENDER_EMAILS_PATH = `${getSettingsPath()}/senderemails`;

export const PRODUCT_TYPE_PATH = '/producttype';
export const getPresetGroupsPath = () => `${BASE_PRODUCTS_PATH}${PRODUCT_TYPE_PATH}`;
export const getPresetGroupsPathWithModal = () => `${getPresetGroupsPath()}?addPresetGroup=true`;
export const CATEGORIES_PATH = '/categories';
export const INVENTORY_WAREHOUSE_PATH = 'inventory/warehouse/:inventoryWarehouseId';
export const EXTERNAL_INVENTORY_SOURCE_PATH = 'externalinv/:externalInventorySourceId';
export const EXTERNAL_INVENTORY_PATH = '/externalinv';
export const INVENTORY_PATH = '/inventory';
export const getProductsInventoryPath = () => `${BASE_PRODUCTS_PATH}${INVENTORY_PATH}`;
export const PURCHASE_ORDERS_PATH = '/purchaseorders';
export const PURCHASE_ORDER_DETAILS_PATH = `:purchaseOrderId`;
export const SUPPLIERS_PATH = '/suppliers';
export const SUPPLIERS_DETAILS_PATH = `:supplierId`;

export const TRANSFER_ORDERS_PATH = '/transferorders';
export const TRANSFER_ORDER_DETAILS_PATH = ':transferOrderId';

export const getCheckoutRatesPath = (storeGuid) => `${BASE_SETTINGS_PATH}/stores/${storeGuid}/checkoutrates`;
export const getProductInventoryPath = () => `${BASE_PRODUCTS_PATH}${INVENTORY_PATH}`;

export const SPEEDSHIP_TERMS_PATH = '/speedship-terms';

export const BASE_FREIGHT_PATH = '/freight';
export const LTL_FREIGHT_PATH = '/freight/ltl';
export const LTL_FREIGHT_PENDING_QUOTES_PATH = '/freight/ltl/pending-quotes';
export const LTL_FREIGHT_BOOKED_PATH = '/freight/ltl/booked';
export const LTL_FREIGHT_VOIDED_PATH = '/freight/ltl/voided';
// Retained only so the renamed view can redirect bookmarks of the old Cancelled sub-view.
export const LTL_FREIGHT_CANCELLED_PATH_LEGACY = '/freight/ltl/cancelled';
export const FREIGHT_COMMODITY_PRESET_PATH = '/freight/commodity-preset';
